import styled from "styled-components";

const ProfilLayout = styled.section`
  width: 48%;
  margin: 1%;
  padding: 1%;
  background-color: #4e4643;
  border-radius: 20px;
  box-shadow: 0 5px 5px #000000;
  height: fit-content;
  @media screen and (max-width: 600px) {
    width: 90%;
  }
`;

export default ProfilLayout;
